
import Box from "../../../assets/outline/Box.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function BoxIcon({ className, dataTestid = "BoxIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Box data-testid={dataTestid} className={classes} {...rest} />
  );
}
